import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { User } from '../../../shared/classes/user';
import { Option } from './option';
import { TdDialogService, TdLoadingService } from '@covalent/core';
import { UserService } from '../user.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'app-options',
  templateUrl: './options.component.html',
  styleUrls: ['./options.component.scss'],
  providers: [UserService]
})
export class OptionsComponent implements OnInit {

  currentOption: Option;
  originalOption: Option;

  languages: any[] = [];

  constructor(
    private _dialogService: TdDialogService,
    private _loadingService: TdLoadingService,
    private _userService: UserService,
    public _authService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    
    this._loadingService.register('loading');

    //TODO get this fromt he backend
    this.originalOption = {
      id: "1",
      language: "English",
      printer: ""
    }

    this.currentOption = this.originalOption;



    this._loadingService.resolve('loading');
  }

  changed(): boolean {
    for (let prop in this.currentOption) {
      if (this.currentOption[prop] != this.originalOption[prop]) {
        return true;
      }
    }

    return false;
  }

  getLanguages() {
    this._userService.getLanguages().subscribe(
    response => {
      this.languages = response;
    });
  }

  goBack() {
    this.router.navigate(['/admin', 'users', 'list']);
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/admin/options/options.component.ts